import {
  Flex,
  Box,
  Text,
  List,
  Modal,
  Button,
  Divider,
  ListItem,
  ModalBody,
  ModalFooter,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { useState } from "react";
import DataBox from "components/databox";
import moment from "moment";

const RequestViewModal = ({ isOpen, onClose, data }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={4}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            View Bag Request
          </Text>
          <Divider />
          <Box>
            <Flex flexDirection={"column"} gap={6} mt={6}>
              <Box>
                <Text
                  color={"#000000"}
                  fontFamily="PlusJakartaSansSemiBold"
                  fontSize={"16px"}
                  lineHeight={"22px"}
                  textTransform={"capitalize"}
                  mb={2}
                >
                  Request Details
                </Text>
                <Box
                  border="1px solid #D9D9D9"
                  borderRadius="8px"
                  p={4}
                  gap={3}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <Flex gap={4}>
                    <DataBox
                      label={"Request ID"}
                      data={data?.id}
                      labelColor={"#000000"}
                      containerStyles={{
                        minHeight: "44px",
                      }}
                    />
                    <DataBox
                      label={"Request Date"}
                      data={moment(data?.date_requested).format("DD/M/YYYY")}
                      labelColor={"#000000"}
                      containerStyles={{
                        minHeight: "44px",
                      }}
                    />
                  </Flex>
                  <Flex gap={4}>
                    <DataBox
                      label={"No. of Bags"}
                      data={data?.number_of_bags}
                      labelColor={"#000000"}
                      containerStyles={{
                        minHeight: "44px",
                      }}
                    />
                    <DataBox
                      label={"No. of Items"}
                      data={data?.number_of_items_requested}
                      labelColor={"#000000"}
                      containerStyles={{
                        minHeight: "44px",
                      }}
                    />
                  </Flex>
                  {/* <DataBox
                    label={"Expected Date"}
                    // data={data?.number_of_items_requested}
                    labelColor={"#000000"}
                    containerStyles={{
                      minHeight: "44px",
                    }}
                  /> */}
                  <DataBox
                    label={"Status"}
                    data={data?.status}
                    labelColor={"#000000"}
                    containerStyles={{
                      minHeight: "44px",
                    }}
                  />
                  <Box
                    bg="#D9D9D966"
                    p={2}
                    borderRadius="4px"
                    display="inline-block"
                    maxW="max-content"
                  >
                    <List spacing={1} styleType="disc" pl={2}>
                      <ListItem
                        fontSize={"8px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#000000"}
                      >
                        <Text as="span" color={"#FF0000"}>
                          Requested
                        </Text>{" "}
                        - Those who have only been requested from the seller.
                      </ListItem>
                      <ListItem
                        fontSize={"8px"}
                        fontFamily={"PlusJakartaSansRegular"}
                        color={"#000000"}
                      >
                        <Text as="span" color={"#157E36"}>
                          Sent
                        </Text>{" "}
                        Those who have sent by the KWC team towards the seller.
                      </ListItem>
                    </List>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
        </ModalBody>

        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"transparent"}
              border={"1px solid #000000"}
              color="#000000"
              size="12px"
              borderRadius="8px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              Close
            </Button>
            {/* <Button
              bg="#000000"
              borderRadius="8px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"174px"}
              h={"40px"}
              textTransform={"uppercase"}
              //   onClick={formik.handleSubmit}
            >
              Save
            </Button> */}
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RequestViewModal;
